import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eAccMonKhongTinhHocPhiActionIds,
  IAccMonKhongTinhHocPhiActionTypes,
} from "../../action-types/category/IMonKhongTinhHocPhiActions";
import { IAccMonKhongTinhHocPhi } from "../../../model/respone/category/IAccMonKhongTinhHocPhi";
import { monKhongTinhHocPhiApi } from "../../../api/category/monKhongTinhHocPhiApi";

export function* monKhongTinhHocPhiSaga(): any {
  yield takeLatest(eAccMonKhongTinhHocPhiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eAccMonKhongTinhHocPhiActionIds.SAVE_START, saveWorker);
  yield takeEvery(eAccMonKhongTinhHocPhiActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(monKhongTinhHocPhiApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.monKhongTinhHocPhi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.monKhongTinhHocPhi.LOAD_ERRR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
function* saveWorker(action: IAccMonKhongTinhHocPhiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IAccMonKhongTinhHocPhi;
  if (payload.id > 0) {
    res = yield call(monKhongTinhHocPhiApi.Update, payload);
  } else {
    res = yield call(monKhongTinhHocPhiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.monKhongTinhHocPhi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.monKhongTinhHocPhi.SAVE_ERROR(
          res.message ?? "Có lỗi",
        ),
      );
    }
  }
}

function* deleteWorker(action: IAccMonKhongTinhHocPhiActionTypes): any {
  const res: IBaseRespone = yield call(
    monKhongTinhHocPhiApi.Delete,
    action.payload as number,
  );
  if (res.is_success) {
    yield put(rootActions.category.monKhongTinhHocPhi.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.monKhongTinhHocPhi.DELETE_ERROR(
        res.message ?? "Có lỗi",
      ),
    );
  }
}
